import React from 'react'
import { useLazyLoadQuery, graphql } from 'react-relay'

import { GuildsScreenAllList } from './GuildsScreenAllList'

import { GuildsScreenAllQuery } from './__generated__/GuildsScreenAllQuery.graphql'

export const GuildsScreenAll = () => {
  const data = useLazyLoadQuery<GuildsScreenAllQuery>(
    graphql`
      query GuildsScreenAllQuery {
        ...GuildsScreenAllList_query
      }
    `,
    {}
  )

  return <GuildsScreenAllList query={data} />
}

export default GuildsScreenAll
